import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { DatePipe } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { DashboardComponent } from './dashboard/dashboard.component';
import { MenuComponent } from './menu/menu.component';
import { LoginComponent } from "./login/login.component";
import { LoginlayoutComponent } from './layouts/loginlayout/loginlayout.component';
import { MasterlayoutComponent } from './layouts/masterlayout/masterlayout.component';
import { MenunormalComponent } from './menunormal/menunormal.component';
import { RoleComponent } from './staff/role/role.component';
import { PrivilegeComponent } from './staff/privilege/privilege.component';
import { RolelistComponent } from './staff/role/rolelist/rolelist.component';

import { ChequeComponent } from './master/cheque/cheque.component';
import { ChequelistComponent } from './master/cheque/chequelist/chequelist.component';
import { CenterComponent } from './master/center/center.component';
import { CenterlistComponent } from './master/center/centerlist/centerlist.component';
import { LoanschemeComponent } from './master/loan/loanscheme/loanscheme.component';
import { LoanschemelistComponent } from './master/loan/loanschemelist/loanschemelist.component';
import { LoanapprovallevelComponent } from './master/loan/loanapprovallevel/loanapprovallevel.component';
import { LoanapprovallevellistComponent } from './master/loan/loanapprovallevellist/loanapprovallevellist.component';
import { LedgerComponent } from './master/ledger/ledger.component';
import { LedgerlistComponent } from './master/ledger/ledgerlist/ledgerlist.component';
import { GroupComponent } from './master/group/group.component';
import { GrouplistComponent } from './master/group/grouplist/grouplist.component';
import { LocationComponent } from './master/location/location.component';
import { LocationlistComponent } from './master/location/locationlist/locationlist.component';
import { EnquiryComponent } from './enquiry/enquiry.component';
import { EnquirylistComponent } from './enquiry/enquirylist/enquirylist.component';
import { SurveyentryComponent } from './enquiry/surveyentry/surveyentry.component';
import { SurveyentrylistComponent } from './enquiry/surveyentry/surveyentrylist/surveyentrylist.component';
import { CustomerlistComponent } from './customer/customerlist/customerlist.component';  
import { CustomerComponent } from './customer/customer.component';
import { CenterlinkComponent } from './customer/centerlink/centerlink.component';
import { CentrelinklistComponent } from './customer/centerlink/centrelinklist/centrelinklist.component';
import { LoanapprovalComponent } from './loan/loanapproval/loanapproval.component';
import { LoanComponent } from './loan/loan.component';
import { LoanlistComponent } from './loan/loanlist/loanlist.component';
import { BranchapprovalComponent } from './loan/branchapproval/branchapproval.component';
import { LoantransactionComponent } from './loan/loantransaction/loantransaction.component';
import { LoantransactionlistComponent } from './loan/loantransaction/loantransactionlist/loantransactionlist.component';
import { LoanreceiptComponent } from './loan/loanreceipt/loanreceipt.component';
import { LoanreceiptlistComponent } from './loan/loanreceipt/loanreceiptlist/loanreceiptlist.component';
import { LoaninstallmentsComponent } from './loan/loaninstallments/loaninstallments.component';
import { SavingsComponent } from './savings/savings.component';
import { SavingslistComponent } from './savings/savingslist/savingslist.component';
import { SavingsaccruedComponent } from './savings/savingsaccrued/savingsaccrued.component';
import { SavingsaccruedlistComponent } from './savings/savingsaccrued/savingsaccruedlist/savingsaccruedlist.component';
import { InterestpaymentsComponent } from './savings/interestpayments/interestpayments.component';
import { InterestpaymentslistComponent } from './savings/interestpayments/interestpaymentslist/interestpaymentslist.component';
import { InstallmentchangeComponent } from './settings/installmentchange/installmentchange.component';
import { InstallmentchangelistComponent } from './settings/installmentchange/installmentchangelist/installmentchangelist.component';
import { SavingsinstallmentchangeComponent } from './settings/savingsinstallmentchange/savingsinstallmentchange.component';
import { SavingsinstallmentchangelistComponent } from './settings/savingsinstallmentchange/savingsinstallmentchangelist/savingsinstallmentchangelist.component';
import { DatamanagementComponent } from './settings/datamanagement/datamanagement.component';
import { ChangedateComponent } from './settings/changedate/changedate.component';

import { ChequereceiptComponent } from './cheque/chequereceipt/chequereceipt.component';
import { ChequereceiptlistComponent } from './cheque/chequereceiptlist/chequereceiptlist.component';
import { ChequetransactionComponent } from './cheque/chequetransaction/chequetransaction.component';
import { OpeningbalanceComponent } from './accounts/openingbalance/openingbalance.component';

import { VoucherComponent } from './accounts/voucher/voucher.component';
import { VoucherlistComponent } from './accounts/voucher/voucherlist/voucherlist.component';
import { VoucherapprovalComponent } from './accounts/voucher/voucherapproval/voucherapproval.component';

import { AccountsgroupComponent } from './master/accountsgroup/accountsgroup.component';
import { AccountsgrouplistComponent } from './master/accountsgroup/accountsgrouplist/accountsgrouplist.component';
import { RolemanagementComponent } from "./staff/rolemanagement/rolemanagement.component";
import { SavingstransactionComponent } from './savings/savingstransaction/savingstransaction.component';
import { SavingstransactionlistComponent } from './savings/savingstransaction/savingstransactionlist/savingstransactionlist.component';

import { StaffComponent } from './staff/staff.component';
import { StafflistComponent } from "./staff/stafflist/stafflist.component";

// Reports
import { PopupheaderComponent } from "./loan/shared/popupheader/popupheader.component";
import { FinancialyearpopupComponent } from './loan/shared/popup/financialyearpopup/financialyearpopup.component';
import { RptloanpopupComponent } from './loan/shared/popup/rptloanpopup/rptloanpopup.component';
import { RptloanapplicationpopupComponent } from './loan/shared/popup/rptloanapplicationpopup/rptloanapplicationpopup.component';
import { RptloanapprovalpopupComponent } from './loan/shared/popup/rptloanapprovalpopup/rptloanapprovalpopup.component';
import { RptloanledgerpopupComponent } from './loan/shared/popup/rptloanledgerpopup/rptloanledgerpopup.component';
import { RptloanoutstandingpopupComponent } from './loan/shared/popup/rptloanoutstandingpopup/rptloanoutstandingpopup.component';
import { RptloanreceiptpopupComponent } from './loan/shared/popup/rptloanreceiptpopup/rptloanreceiptpopup.component';
import { RptloansanctionpopupComponent } from './loan/shared/popup/rptloansanctionpopup/rptloansanctionpopup.component';
import { RptcustomerpopupComponent } from './customer/shared/popup/rptcustomerpopup/rptcustomerpopup.component';
import { RptcollectionsheetpopupComponent } from './loan/shared/popup/rptcollectionsheetpopup/rptcollectionsheetpopup.component';
import { RptdemandsheetpopupComponent } from './loan/shared/popup/rptdemandsheetpopup/rptdemandsheetpopup.component';
import { RptpassbookpopupComponent } from './loan/shared/popup/rptpassbookpopup/rptpassbookpopup.component';
import { RptloanemipopupComponent } from './loan/shared/popup/rptloanemipopup/rptloanemipopup.component';
import { RptddfundpopuppComponent } from './loan/shared/popup/rptddfundpopupp/rptddfundpopupp.component';
import { RptinstallmentpopupComponent } from './loan/shared/popup/rptinstallmentpopup/rptinstallmentpopup.component';
import { RptdaybookpopupComponent } from './accounts/reports/popup/rptdaybookpopup/rptdaybookpopup.component';
import { RptdaybookcentrepopupComponent } from './accounts/reports/popup/rptdaybookcentrepopup/rptdaybookcentrepopup.component';
import { RptcashbookpopupComponent } from './accounts/reports/popup/rptcashbookpopup/rptcashbookpopup.component';
import { RpttrailbalancepopupComponent } from './accounts/reports/popup/rpttrailbalancepopup/rpttrailbalancepopup.component';
import { RptledgerpopupComponent } from './loan/shared/popup/rptledgerpopup/rptledgerpopup.component';
import { ConfirmationdialogComponent } from './utility/confirmationdialog/confirmationdialog.component';
// import { AppRoutingModule } from "./app-routing.module";
import { ToastrModule } from 'ngx-toastr';
import { SavingsreceiptslistComponent } from './savings/savingsreceiptslist/savingsreceiptslist.component';
import { SavingsreceiptsComponent } from './savings/savingsreceiptslist/savingsreceipts/savingsreceipts.component';
import { StaffmasterComponent } from './staff/staffmaster/staffmaster.component';
import { UsermanagementComponent } from "./staff/usermanagement/usermanagement.component";
// import {ScrollbarModule} from "ngx-scrollbar";
// import { NgScrollbarModule } from "ngx-scrollbar/lib/ng-scrollbar.module";
// import { NgScrollbarModule } from 'ngx-scrollbar';

// import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION,PB_DIRECTION, 
  NgxUiLoaderRouterModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { AuthGuard } from "./helpers/auth.guard";
import { UnauthorisedComponent } from "./layouts/unauthorised/unauthorised.component";
import { ChangepasswordComponent } from './staff/changepassword/changepassword.component';
import { ProfilesComponent } from './staff/profiles/profiles.component';
import { ChartsModule, ThemeService   } from 'ng2-charts';
import { LoanchartComponent } from './charts/loanchart/loanchart.component';
import { CustomerschartComponent } from './charts/customerschart/customerschart.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { CancelButtonComponent } from './buttons/cancel-button/cancel-button.component';
import { DefaultcaseComponent } from './settings/defaultcase/defaultcase.component';
import { DefaultcaselistComponent } from './settings/defaultcase/defaultcaselist/defaultcaselist.component';
import { JwtintercepterService } from "./login/shared/jwtintercepter.service";
import { PrepaidcaseComponent } from './settings/prepaidcase/prepaidcase.component';
import { PrepaidcaselistComponent } from './settings/prepaidcase/prepaidcaselist/prepaidcaselist.component';
import { SavingscustomdefaultcaseComponent } from './settings/savingscustomdefaultcase/savingscustomdefaultcase.component';
import { SavingscustomdefaultcaselistComponent } from './settings/savingscustomdefaultcase/savingscustomdefaultcaselist/savingscustomdefaultcaselist.component';
import { HolidaycollectionComponent } from './holidaycases/holidaycollection/holidaycollection.component';
import { HolidayloanComponent } from './holidaycases/holidayloan/holidayloan.component';
import { DaycloseComponent } from './accounts/dayclose/dayclose.component';
// import { Document } from "./helpers/document"; 

// to use canactivate with data params. not working while import.
export enum Document {
    
  Dashboard = 3001,
  chequelist = 3002,
  centerlist = 3003,
  loanschemelist = 3004,
  loanapprovallist = 3005,
  accountsgrouplist = 3006,
  ledgerlist = 3007,
  grouplist = 3008,
  locationlist = 3009,
  stafflist = 3010,
  staffmaster = 3011,
  rolelist = 3012,
  privilege = 3013,
  enquirylist = 3014,
  surveyentrylist = 3015,
  customerlist = 3016,
  centrelinklist = 3017,
  chequereceiptlist = 3018,
  chequetransaction = 3019,
  loanlist = 3020,
  branchapproval = 3021,
  Loanapproval = 3022,
  loantransactionlist = 3023,
  loanreceiptlist = 3024,
  loaninstallments = 3025,
  savingslist = 3026,
  savingsaccruedlist = 3027,
  savingstransactionlist = 3028,
  savingsreceiptslist = 3029,
  voucherlist = 3030,
  Voucherapproval = 3031,
  Openingbalance = 3032,
  installmentchangelist = 3033,
  savingsinstallmentchangelist = 3034,
  datamanagement = 3035,
  changedate = 3036,
  interestpaymentslist = 3037,
  changepassword = 3038,
  defaultcaselist = 3039,
  prepaidcaselist = 3040,
  savingscustomdefaultcaselist = 3041,
  loantransaction = 3043,
}

const routes: Routes = [

  { 
    path: '',
    component: LoginComponent ,
  },
  // { 
  //   path: 'login',
  //   component: LoginlayoutComponent ,
  //   children: [
  //     { path: '', component: LoginComponent,  }
  //   ]
  // },
  { 

    path: 'dashboard',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DashboardComponent,  }
    ],
    // canActivate: [AuthGuard],
    // data: { roles:  Document.Dashboard  }
  },

  {
    path: 'customer',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CustomerComponent }
    ]
  },

  {
    path: 'menu',
    // component: CustomerComponent,
    children: [
      { path: '', component: MenuComponent }
    ]
  },

  { 
    path: 'chequelist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequelistComponent },
      // { path: 'chequelist', component: ChequeComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.chequelist] }
  },
  {
    path: 'cheque',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequeComponent },
    ]
  },
  {
    path: 'cheque/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequeComponent },
    ]
  },
  
  { 
    path: 'centerlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CenterlistComponent },
      // { path: 'center', component: CenterComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.centerlist] }
  },
  {
    path: 'center',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CenterComponent },
    ]
  },
  {
    path: 'center/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CenterComponent },
    ]
  },


  { 
    path: 'loanschemelist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanschemelistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loanschemelist] }
  },
  { 
    path: 'loanscheme',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanschemeComponent },
    ]
  },
  {
    path: 'loanscheme/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanschemeComponent },
    ]
  },

  {
    path: 'loanapprovallevellist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanapprovallevellistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loanapprovallist] }
  },

  {
    path: 'loanapprovallevel',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanapprovallevelComponent },
    ]
  },
  {
    path: 'loanapprovallevel/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanapprovallevelComponent },
    ]
  }, 

  {
    path: 'ledgerlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LedgerlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.ledgerlist] }
  },
  {
    path: 'ledger',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LedgerComponent },
    ]
  },
  {
    path: 'ledger/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LedgerComponent },
    ]
  },

  {
    path: 'group',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: GroupComponent },
    ]
  },
  {
    path: 'group/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: GroupComponent },
    ]
  },
  { 
    path: 'grouplist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: GrouplistComponent },
      { path: 'group', component: GroupComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.grouplist] }
  },
  {
    path: 'location',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LocationComponent },
    ]
  },
  {
    path: 'location/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LocationComponent },
    ]
  },
  { 
    path: 'locationlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LocationlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.locationlist] }
  },

  {
    path: 'enquiry',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: EnquiryComponent },
    ]
  },
  {
    path: 'enquiry/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: EnquiryComponent },
    ]
  }, 
  { 
    path: 'enquirylist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: EnquirylistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.enquirylist] }
  },

  {
    path: 'surveyentry', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SurveyentryComponent }
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'surveyentry/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SurveyentryComponent }
    ]
  },
  { 
    path: 'surveyentrylist', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SurveyentrylistComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.surveyentrylist] }
  },
  {
    path: 'customer',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CustomerComponent },
    ]
  },
  {
    path: 'customer/:Id/:Id1', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CustomerComponent },
    ]
  },
  { 
    path: 'customerlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CustomerlistComponent },
      { path: 'customer', component: CustomerComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.customerlist] }
  },

  {
    path: 'centerlink',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CenterlinkComponent },
    ]
  },
  {
    path: 'centerlink/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CenterlinkComponent },
    ]
  },
  { 
    path: 'centrelinklist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: CentrelinklistComponent },
      { path: 'centerlink', component: CenterlinkComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.centrelinklist] }
  }, 

  { 
    path: 'Loanapproval',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanapprovalComponent }
    ]
  },
  
  { 
    path: 'loanapprovallist',
    component: MasterlayoutComponent,
    children: [
      { path: 'Loanapproval', component: LoanapprovalComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loanapprovallist] }
  },
  {
    path: 'loan',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanComponent },
    ]
  },
  {
    path: 'loan/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanComponent },
    ]
  },
  { 
    path: 'loanlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanlistComponent },
      // { path: 'loan', component: LoanComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loanlist] }
  },

  {
    path: 'branchapproval',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: BranchapprovalComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.branchapproval] }
  },
  {
    path: 'branchapproval/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: BranchapprovalComponent },
    ]
  },

  {
    path: 'loantransaction',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoantransactionComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loantransaction] }
  }, 
  {
    path: 'loantransaction/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoantransactionComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loantransaction] }
  },   
  {
    path: 'loantransactionlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoantransactionlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loantransactionlist] }
  }, 
  
  {
    path: 'loanreceipt',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanreceiptComponent },
    ]
  },
  {
    path: 'loanreceipt/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanreceiptComponent },
    ]
  },
  { 
    path: 'loanreceiptlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoanreceiptlistComponent },
      { path: 'loanreceipt', component: LoanreceiptComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.loanreceiptlist] }
  },

  {
    path: 'loaninstallments',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: LoaninstallmentsComponent },
    ]
  },  

  {
    path: 'chequereceipt',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequereceiptComponent },
    ]
  },
  {
    path: 'chequereceipt/:Id', 
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequereceiptComponent },
    ]
  },
  { 
    path: 'chequereceiptlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequereceiptlistComponent },
      { path: 'location', component: LocationComponent }
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.chequereceiptlist] }
  },

  { 
    path: 'chequetransaction',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChequetransactionComponent },
    ]
  },

  {
    path: 'savings',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsComponent },
    ]
  },
  {
    path: 'savings/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsComponent },
    ]
  },
  { 
    path: 'savingslist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingslistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingslist] }
  },

  {
    path: 'savingsaccrued',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsaccruedComponent },
    ]
  },
  {
    path: 'savingsaccrued/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsaccruedComponent },
    ]
  },
  {
    path: 'savingsaccruedlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsaccruedlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingsaccruedlist] }
  },
  {
    path: 'interestpayments',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InterestpaymentsComponent },
    ]
  },
  {
    path: 'interestpayments/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InterestpaymentsComponent },
    ]
  },

  { 
    path: 'interestpaymentslist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InterestpaymentslistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.interestpaymentslist] }
  },

  {
    path: 'installmentchange',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InstallmentchangeComponent },
    ]
  }, 
  {
    path: 'installmentchange/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InstallmentchangeComponent },
    ]
  },   
  {
    path: 'installmentchangelist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: InstallmentchangelistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.installmentchangelist] }
  }, 

  {
    path: 'savingsinstallmentchange',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsinstallmentchangeComponent },
    ]
  }, 
  {
    path: 'savingsinstallmentchange/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsinstallmentchangeComponent },
    ]
  },   
  {
    path: 'savingsinstallmentchangelist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsinstallmentchangelistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingsinstallmentchangelist] }
  },
  {
    path: 'datamanagement',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DatamanagementComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.datamanagement] }
  }, 
  {
    path: 'changedate',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChangedateComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.changedate] }
  },  

  {
    path: 'Ledger',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: RptledgerpopupComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.ledgerlist] }
  },

  {
    path: 'menulist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: MenuComponent },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: 'Openingbalance',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: OpeningbalanceComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.Openingbalance] }
  },

  {
    path: 'Voucherapproval',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: VoucherapprovalComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.Voucherapproval] }
  },

  {
    path: 'accountsgrouplist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: AccountsgrouplistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.accountsgrouplist] }
  }, 

  {
    path: 'accountsgroup',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: AccountsgroupComponent },
    ]
  }, 

  {
    path: 'accountsgroup/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: AccountsgroupComponent },
    ]
  }, 

  {
    path: 'savingstransaction',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingstransactionComponent },
    ]
  }, 
  {
    path: 'savingstransaction/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingstransactionComponent },
    ]
  },   
  {
    path: 'savingstransactionlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingstransactionlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingstransactionlist] }
  }, 

  {
    path: 'voucher',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: VoucherComponent },
    ]
  },
  {
    path: 'voucher/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: VoucherComponent },
    ]
  },  
  {
    path: 'voucherlist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: VoucherlistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.voucherlist] }
  },
  
  {
    path: 'savingsreceipts',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsreceiptsComponent },
    ]
  },
  {
    path: 'savingsreceipts/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsreceiptsComponent },
    ]
  },  
  {
    path: 'savingsreceiptslist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingsreceiptslistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingsreceiptslist] }
  },
  {
    path: 'staff',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: StaffComponent },
    ]
  }, 
  {
    path: 'staff/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: StaffComponent },
    ]
  },   
  {
    path: 'stafflist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: StafflistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.stafflist] }
  }, 

  {
    path: 'privilege',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: PrivilegeComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.privilege] }
  },  

  {
    path: 'rolelist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: RolelistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.rolelist] }
  }, 

  {
    path: 'role',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: RoleComponent },
    ]
  }, 

  {
    path: 'role/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: RoleComponent },
    ]
  }, 

  {
    path: 'defaultcaselist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DefaultcaselistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.defaultcaselist] }
  }, 

  {
    path: 'defaultcase',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DefaultcaseComponent },
    ]
  }, 

  {
    path: 'defaultcase/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DefaultcaseComponent },
    ]
  }, 
  
  {
    path: 'prepaidcaselist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: PrepaidcaselistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.prepaidcaselist] }
  }, 

  {
    path: 'prepaidcase',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: PrepaidcaseComponent },
    ]
  }, 

  {
    path: 'prepaidcase/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: PrepaidcaseComponent },
    ]
  }, 

  {
    path: 'savingscustomdefaultcaselist',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingscustomdefaultcaselistComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.savingscustomdefaultcaselist] }
  }, 

  {
    path: 'savingscustomdefaultcase',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingscustomdefaultcaseComponent },
    ]
  }, 

  {
    path: 'savingscustomdefaultcase/:Id',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: SavingscustomdefaultcaseComponent },
    ]
  }, 

  {
    path: 'Rolemanagement',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: RolemanagementComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.rolelist] }
  },

  {
    path: 'staffmaster',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: StaffmasterComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.staffmaster] }
  },

  // { path: '**', redirectTo: 'LoginComponent' },
  
  {
    path: 'changepassword',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ChangepasswordComponent },
    ],
    canActivate: [AuthGuard],
    data: { documentId: [ Document.changepassword] }
  },

  {
    path: 'profiles',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: ProfilesComponent },
    ],
  },

  {
    path: 'holidaycollection',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: HolidaycollectionComponent },
    ],
    // canActivate: [AuthGuard],
    // data: { documentId: [ Document.holidayloan] }
  }, 

  {
    path: 'holidayloan',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: HolidayloanComponent },
    ],
    // canActivate: [AuthGuard],
    // data: { documentId: [ Document.holidayloan] }
  }, 

  {
    path: 'dayclose',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: DaycloseComponent },
    ],
    // canActivate: [AuthGuard],
    // data: { documentId: [ Document.holidayloan] }
  }, 
  
  {
    path: 'unauthorised',
    component: MasterlayoutComponent,
    children: [
      { path: '', component: UnauthorisedComponent },
    ]
  },

  { 
    path: '**',
    component: LoginComponent ,
  },

];

// loader section defined.
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: 'rgba(12,80,219,0.98)',
    bgsOpacity: 0.5,
    bgsPosition: POSITION.bottomRight,
    bgsSize: 40,
    bgsType: SPINNER.threeStrings,
    fgsColor: 'rgba(12,80,219,0.98)',
    fgsPosition: POSITION.centerCenter,
    text: "Loading data, please wait..",
    textColor: "#FFFFFF",
    textPosition: "center-center",
  };

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    CustomerComponent,
    MenuComponent,
    LoginComponent,
    LoginlayoutComponent,
    MasterlayoutComponent,
    MenunormalComponent,
    LoanComponent,
    ChequeComponent,
    ChequelistComponent,
    CenterComponent,
    CenterlistComponent,
    CenterlinkComponent,
    LoanschemeComponent,
    LoanschemelistComponent,
    LoanapprovallevelComponent,
    LoanapprovallevellistComponent,
    LedgerComponent ,
    LedgerlistComponent,
    GroupComponent,
    GrouplistComponent,
    LocationComponent ,
    LocationlistComponent ,
    EnquiryComponent,
    EnquirylistComponent,
    SurveyentryComponent,
    SurveyentrylistComponent,
    CustomerlistComponent ,
    CustomerComponent,
    CenterlinkComponent,
    CentrelinklistComponent,
    LoanapprovalComponent,
    LoanComponent,
    LoanlistComponent,
    BranchapprovalComponent,
    LoantransactionComponent,
    LoantransactionlistComponent,
    LoanreceiptComponent,
    LoanreceiptlistComponent,
    LoaninstallmentsComponent,
    SavingsComponent,
    SavingslistComponent,
    ChequereceiptComponent,
    ChequereceiptlistComponent,
    ChequetransactionComponent,
    SavingsaccruedComponent,
    SavingsaccruedlistComponent,
    InterestpaymentsComponent,
    InterestpaymentslistComponent,
    SavingsinstallmentchangeComponent,
    SavingsinstallmentchangelistComponent,
    InstallmentchangeComponent,
    InstallmentchangelistComponent,
    DatamanagementComponent,
    ChangedateComponent,
    StaffComponent,
    StafflistComponent,

    PopupheaderComponent,
    FinancialyearpopupComponent,
    ChequereceiptComponent,
    OpeningbalanceComponent,
    VoucherComponent,
    VoucherlistComponent,
    VoucherapprovalComponent,
    AccountsgroupComponent,
    AccountsgrouplistComponent,
    RoleComponent,
    PrivilegeComponent,
    RolelistComponent,
    MenuComponent,
    RolemanagementComponent,
    SavingstransactionComponent,
    SavingstransactionlistComponent,
    SavingsreceiptsComponent,
    SavingsreceiptslistComponent,
    StaffmasterComponent,
    
    RptloanpopupComponent,
    RptloanapplicationpopupComponent,
    RptloanapprovalpopupComponent,
    RptloanledgerpopupComponent,
    RptloanoutstandingpopupComponent,
    RptloanreceiptpopupComponent,
    RptloansanctionpopupComponent,
    RptcustomerpopupComponent,
    RptcollectionsheetpopupComponent,
    RptdemandsheetpopupComponent,
    RptpassbookpopupComponent,
    RptloanemipopupComponent,
    RptddfundpopuppComponent,
    RptinstallmentpopupComponent,
    RptledgerpopupComponent,
    RptcashbookpopupComponent,
    RptdaybookpopupComponent,
    RptdaybookcentrepopupComponent,
    RpttrailbalancepopupComponent,
    ConfirmationdialogComponent,
    SavingsreceiptslistComponent,
    SavingsreceiptsComponent,
    StaffmasterComponent,
    UsermanagementComponent,
    UnauthorisedComponent,
    ChangepasswordComponent,
    ProfilesComponent,
    LoanchartComponent,
    CustomerschartComponent,
    FooterComponent,
    CancelButtonComponent,
    DefaultcaseComponent,
    DefaultcaselistComponent,
    PrepaidcaseComponent,
    PrepaidcaselistComponent,
    SavingscustomdefaultcaseComponent,
    SavingscustomdefaultcaselistComponent,
    HolidaycollectionComponent,
    HolidayloanComponent,
    DaycloseComponent,

    ],

  imports: [
    // RouterModule.forRoot([]),  // use it for [routerLink] in html
    
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTabsModule,
    MatDialogModule,
    MatExpansionModule,
    MatPaginatorModule,
    // AppRoutingModule,
    MatAutocompleteModule,
    ToastrModule.forRoot(), // ToastrModule added
    ModalModule.forRoot(),
    RouterModule.forRoot(routes, { useHash: true }),
    
    // NgxUiLoaderModule, // import NgxUiLoaderModule
    // NgxUiLoaderRouterModule, // import NgxUiLoaderRouterModule. By default, it will show foreground loader.
    // If you need to show background spinner, do as follow:
    // NgxUiLoaderRouterModule.forRoot({ showForeground: false })

    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule, // import this module for showing loader automatically when navigating between app routes
    NgxUiLoaderHttpModule,
    ChartsModule
  ],

  providers: [DatePipe, ThemeService,
  {provide:HTTP_INTERCEPTORS, useClass: JwtintercepterService, multi:true}],
  bootstrap: [AppComponent],
  // declarations: [LoanComponent],
  // declarations: [CustomerComponent]

  entryComponents: [

    FinancialyearpopupComponent,
    RptloanpopupComponent,
    RptloanapplicationpopupComponent,
    RptloanapprovalpopupComponent,
    RptloanledgerpopupComponent,
    RptloanoutstandingpopupComponent,
    RptloanreceiptpopupComponent,
    RptloansanctionpopupComponent,
    RptcustomerpopupComponent,
    RptcollectionsheetpopupComponent,
    RptdemandsheetpopupComponent,
    RptpassbookpopupComponent,
    RptloanemipopupComponent,
    RptddfundpopuppComponent,
    RptinstallmentpopupComponent,
    FinancialyearpopupComponent,
    RptcashbookpopupComponent,
    RptdaybookpopupComponent,
    RptdaybookcentrepopupComponent,
    RpttrailbalancepopupComponent,
    RptledgerpopupComponent,
    ConfirmationdialogComponent,
    UsermanagementComponent,
  ]

})

export class AppModule { }
